import { useSelector } from "react-redux";

export default function useFilterSortJobs() {
  const { search, sortBy } = useSelector((state) => state.JobSort);
  const { allJobs, filterBy } = useSelector((state) => state.Jobs);

  // jobs filter and sorting
  const filteredJobs = filterBy
    ? allJobs.filter((job) => job.type === filterBy)
    : allJobs;
  const searchedJobs = filteredJobs.filter((job) =>
    job.title.toLowerCase().startsWith(search.toLowerCase())
  );

  let sortedJobs;
  if (sortBy === "asc") {
    const copyJobs = [...searchedJobs];
    sortedJobs = copyJobs.sort((a, b) => Number(a.salary) - Number(b.salary));
  } else if (sortBy === "dsc") {
    const copyJobs = [...searchedJobs];
    sortedJobs = copyJobs.sort((a, b) => Number(b.salary) - Number(a.salary));
  } else {
    sortedJobs = searchedJobs;
  }

  return sortedJobs;
}
